import React, { Component } from 'react';
import axios from 'axios';
import { convertLatLngtoPoint, convertCoordinatetoLatLng, mapRemoveLayer } from './utils.js'



const liff = window.liff;
const apiUrl = 'https://my.ugravity.net/api/';


class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      userLineID: '',
      pictureUrl: '',
      ready: true,
      username: '',
      checkareawork: 'NA',
    };
  }

  componentDidMount = async () => {
    var x = document.getElementById("demo");
    x.innerHTML = "กำลังตรวจสอบข้อมูล...";
    try {
      await liff.init({ liffId: '1656661803-y1dPY7A9' }).catch(err => { throw err });
      if (liff.isLoggedIn()) {
        let getProfile = await liff.getProfile();
        let getIDToken = await liff.getIDToken();
        // console.log("---------getProfile-----------")
        // console.log(getProfile);
        // console.log("---------getIDToken-----------")
        // console.log(getIDToken);
        x.innerHTML = "กรุณากดปุ่มบันทึกเวลาทำงาน...";
        this.setState({
          name: getProfile.displayName,
          userLineID: getProfile.userId,
          pictureUrl: getProfile.pictureUrl,
        });

      } else {
        liff.login();
      }

    } catch (error) {
      console.error('LIFF initialization failed ', error);
      x.innerHTML = "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาลองใหม่อีกครั้ง";
      return;

    }

  }

  getLocation = (e) => {
    var x = document.getElementById("demo");
    x.innerHTML = "กำลังบันทึกข้อมูล...";
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    } else {
      x.innerHTML = "ไม่สามารถบันทึกเวลาได้ เนื่องจากไม่พบพิกัดสถานที่ทำงาน";
    }
  }

  showPosition = (position) => {
    var x = document.getElementById("demo");
    // console.log(position.coords.latitude);
    // console.log(position.coords.longitude);
    let point = convertLatLngtoPoint(position.coords.latitude, position.coords.longitude);
    let a = point[0];
    let b = point[1];
    // console.log(point);
    console.log(point);

    const callPostAPI = async () => {
      try {
        console.log(this.state.userLineID);
        axios.post(apiUrl + 'updatetimestamp', { line_uid: this.state.userLineID, a: a, b: b })
          .then(response => {
            // do something about response
            console.log(response.data);
            x.innerHTML = response.data.result;
            this.setState({ checkareawork: response.data.checkareawork })
            if (response.data.result == 'ไม่พบข้อมูลผู้ใช้งาน') {
              this.setState({ ready: false })
            } else {
              // if (!liff.isInClient()) {
              //   window.alert('This button is unavailable as LIFF is currently being opened in an external browser.');
              // } else 
              {
                var tdate = new Date();

                // liff.sendMessages([
                //   {
                //     type: 'text',
                //     text: 'คุณได้บันทึกเวลางานเสร็จสิ้น ณ เวลา ',//+tdate.toStrin(),
                //   },
                // ])
                //   .then(() => {
                //     liff.closeWindow();
                //   })
                //   .catch((error) => {
                //     window.alert('Error sending message: ' + error);
                //   });

              }
            }


            //console.log(response.data);
          })
          .catch(function (error) {
            console.log(error);
            x.innerHTML = 'บันทึกข้อมูลไม่สำเร็จกรุณากดปุ่ม บันทึกใหม่อีกครั้ง...';


            console.error(error)
          })
      }
      catch (error) {
      }
    }
    callPostAPI();
  }

  handleChangeusername = (e) => {
    this.setState({ username: e.target.value })
  }

  setLineUser = () => {
    const callPostAPI = async () => {
      try {
        axios.post(apiUrl + 'updateuserline', { line_uid: this.state.userLineID, username: this.state.username })
          .then(response => {
            var x = document.getElementById("result2");
            x.innerHTML = response.data.result;
            if (response.data.result == 'ไม่พบข้อมูลผู้ใช้งาน') {
              this.setState({ ready: false })
            } else {
              var x = document.getElementById("demo");
              x.innerHTML = '';
              this.setState({ ready: true })
            }
            // do something about response
          })
          .catch(function (error) {
            console.error(error)
          })
      }
      catch (error) {
      }
    }
    callPostAPI();
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="support">
            <h1>ลงบันทึกเวลางานประจำวัน</h1>
            <div style={{ display: (this.state.ready ? 'block' : 'none') }}>
              <button style={{
                height: '40px',
                backgroundColor: (this.state.userLineID == '' ? 'gray' : '#2eb85c'),
                border: 'none',
                borderRadius: '10px',
                padding: '10px',
                fontSize: '15px',
                color: 'white'

              }} disabled={this.state.userLineID == '' ? true : false} onClick={(e) => this.getLocation(e)}>บันทึกเวลาทำงาน</button>

              <p id="demo"></p>
              <div id="checkareawork" style={{
                color: 'red', display: (this.state.checkareawork == 'outside' ? 'block' : 'none')
              }}>
                คุณบันทึกเวลาทำงานนอกเขตพื้นที่ทำงาน
              </div>
            </div>
            <div style={{ display: (this.state.ready ? 'none' : 'block') }}>
              <p>ไม่พบข้อมูลผู้ใช้งาน</p>
              <label>
                กรุณาป้อนชื่อผู้ใช้ระบบ :
                <input type="text" value={this.state.username} onChange={this.handleChangeusername} />
              </label>
              <button onClick={() => this.setLineUser()}>
                บันทึก
              </button>
              <p id="result2"></p>
            </div>

            {/* <p>ชื่อ {this.state.name}</p>
            <p>Line ID {this.state.userLineID}</p>
            <img alt='pic' src={this.state.pictureUrl} /> */}
          </div>
        </header>
      </div>
    );
  }
}

export default App;